import { KTCard } from '../../../_dashboard/helpers'
import FooterManagement from './FooterManagement'

const FooterListWrapper = () => (
  <KTCard>
    <FooterManagement />
  </KTCard>
)

export { FooterListWrapper }
